<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div id="divmanufactureofmaterialList" class="grid-div">
    <div class="modal-body body-modal mt-2">
      <div class="username px-1">
        <label>User name : {{ userName }}</label>
      </div>
      <input
        data-val="true"
        data-val-number="The field CustomMaterialId must be a number."
        data-val-required="The CustomMaterialId field is required."
        type="hidden"
        value="0"
      />
      <piqet-angular-portlet
        [columnDefs]="processColumnDef"
        [gridData]="loginLogsHistory"
        [totalCount]="totalCount"
        [isServerSide]="true"
        (searchEvent)="searchRecord($event)"
        (paginationChangeEvent)="paginationChanged($event)"
        (sortChangeEvent)="sortChanged($event)"
        [class]="'fixedHeight'"
        [isSearchInputPosition]="isSearchInputPosition"
      >
      </piqet-angular-portlet>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
  </div>
</div>
